<template>
  <div class="not-found">
    <span class="not-found-text">404</span>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.not-found {
  &-text {
    color: $color_primary;
  }
}
</style>
